import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { isoWebPageURL } from "../../models/nominals";
import { ICategoryInfo } from "../../models/tempur-love";
import { Link } from "../Link";
import { SVGIcon } from "../SVGIcon";

type ISocialIconsProps = Immutable<{
    categories: readonly ICategoryInfo[];
    loveRootUrl: string;
    city?: string | null;
    state?: string | null;
    pageUrl: string;
    tileImageUrl: string;
    twitterHandle: string;
    showCategoryImages?: boolean;
    showShare?: boolean;
}>;

export const SocialIcons = (props: ISocialIconsProps): React.JSX.Element => {
    const showShare = props.showShare ?? true;
    const shareUrl = encodeURIComponent(props.pageUrl);
    const shareImageUrl = encodeURIComponent(props.tileImageUrl);

    return (
        <footer className="social-icons">
            <div className="social-icons__tags">
                {props.categories.map((category) => (
                    <Link
                        key={category.slug}
                        href={isoWebPageURL.wrap(
                            `${props.loveRootUrl}c/${encodeURIComponent(category.slug)}/`,
                        )}
                        title={category.name}
                    >
                        {props.showCategoryImages && category.image_url ? (
                            <img
                                src={category.image_url}
                                alt={category.name}
                                width={60}
                                height={60}
                                loading="lazy"
                                decoding="async"
                            />
                        ) : (
                            category.name
                        )}
                    </Link>
                ))}
                {props.city && props.state && (
                    <span>
                        {props.city}, {props.state}
                    </span>
                )}
            </div>
            {showShare && (
                <dl className="blog__share">
                    <dt>{t`Share`}</dt>
                    <dd>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title={t`Share on X`}
                            aria-label={t`Share on X`}
                            href={`https://twitter.com/intent/tweet?url=${shareUrl}&via=${encodeURIComponent(props.twitterHandle.replace(/^@/, ""))}`}
                        >
                            <SVGIcon name="xLogo" />
                        </a>
                    </dd>
                    <dd>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title={t`Share on Facebook`}
                            aria-label={t`Share on Facebook`}
                            href={`https://www.facebook.com/sharer.php?u=${shareUrl}`}
                        >
                            <SVGIcon name="facebookF" />
                        </a>
                    </dd>
                    <dd>
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            title={t`Share on Pinterest`}
                            aria-label={t`Share on Pinterest`}
                            href={`https://pinterest.com/pin/create/button/?url=${shareUrl}&media=${shareImageUrl}`}
                        >
                            <SVGIcon name="pinterestP" />
                        </a>
                    </dd>
                </dl>
            )}
        </footer>
    );
};
